import React, { useEffect, useState } from "react";
import { ReactComponent as ArrowIcon } from "../../assets/arrow-icon.svg";
import "./sidebar.scss";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import { useLayout } from "../../context/layoutContext";
import Permission from "../general/permission/permission";

function SidebarItem({
  icon,
  name,
  id,
  subMenu,

  path,
}: {
  icon: string;
  name: string;
  subMenu: { label: string; path: string; permission: string }[] | undefined;

  id: string;
  path: string;
}) {
  const layout = useLayout();
  const location = useLocation();
  const [isSelected, setIsSelected] = useState(false);
  const [isOpened, setIsOpened] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (subMenu && !layout.isSidebarClosed) {
      if (subMenu.find((item) => location.pathname.startsWith(item.path))) {
        setIsSelected(true);
        if (!isOpened) {
          setIsOpened(true);
        }
      } else {
        setIsSelected(false);
        setIsOpened(false);
      }
    } else {
      if (layout.isSidebarClosed) {
        setIsSelected(false);
        setIsOpened(false);
      } else if (location.pathname === path) {
        setIsSelected(true);
      } else {
        setIsSelected(false);
      }
    }
  }, [location.pathname, location, layout.isSidebarClosed]);

  const handleClick = () => {
    if (layout.isSidebarClosed) {
      layout.toggleSidebar();
    }
    if (subMenu && subMenu.length > 0) {
      navigate(subMenu[0].path);
      if (!isOpened) {
        setIsOpened(true);
      }
    }
  };

  const handleArrowClick = (e: any) => {
    e.stopPropagation();

    setIsOpened(!isOpened);
  };

  return (
    <div
      className={`${isSelected ? "menu_item selected" : "menu_item"} ${
        isOpened ? "opened" : ""
      }`}
    >
      {subMenu ? (
        <>
          <div className={"main"} onClick={handleClick}>
            <div>
              <div className={`icon ${id === "4" && "stroke"}`}>{icon}</div>
              <div className={"text"}>{name}</div>
            </div>

            <div className={"arrow submenu"} onClick={handleArrowClick}>
              <ArrowIcon fill={"#fff"} />
            </div>
          </div>

          <div className={isOpened ? "open-submenu" : "hidden-submenu"}>
            {isOpened && subMenu?.length
              ? subMenu.map((section, index) => {
                  const isSelectedSubMenu = section.path === location.pathname;
                  return (
                    <Permission
                      requiredPermission={section.permission}
                      key={index}
                    >
                      <Link to={section.path} key={index}>
                        <div
                          className={`submenu-item ${
                            isSelectedSubMenu ? "submenu-selected" : ""
                          }`}
                        >
                          <div className="icon" />
                          <div className={"text"}>{section.label}</div>
                        </div>
                      </Link>
                    </Permission>
                  );
                })
              : null}
          </div>
        </>
      ) : (
        <Link to={path}>
          <div className={"main"}>
            <div>
              <div className={"icon"}>{icon}</div>
              <div className={"text"}>{name}</div>
            </div>

            <div className={"arrow"}>
              <ArrowIcon fill={"#fff"} />
            </div>
          </div>
        </Link>
      )}
    </div>
  );
}
export default SidebarItem;
